module.exports = __webpack_public_path__ + "images/icons/care-match.b6a3f564cd220a3d99fd764de87e3b0d.png";